(function (angular) {
  'use strict';
  
  // MODULE DEFINITION
  angular.module('app.user', ['app.firebase']);

})(angular);